<template>
  <layout :width="1024">
    <div class="result-page">
      <div class="content-wrapper">
        <back-button :to="backUrl" />
        <a class="btn btn-success btn-lg" target="_blank" :href="reportUrl">
          Tulosta
          <i class="fas fa-print"></i>
        </a>
        <br />
        <br />

        <p v-if="initParams && initParams.description" style="font-weight: bold;">
          {{ initParams.description }}
        </p>

        <p>
          Kustannusarvio perustuu tässä käytettyihin kohteen tietoihin. Arvio perustuu puhelinkeskustelussa saatuihin
          tietoihin ilman kohteen lähtötilanteen kartoitusta, korjaussuunnitelmaa ja tarkempia tuotevalintoja.
          Arvio esitetään sitoumuksetta.
        </p>

        <p>
          Ennen toimenpiteisiin ryhtymistä tulisi ammattilaisen suorittaa korjattavan kohteen tutkimus, tehdä tutkimukseen
          perustuva suunnitelma kaorjaustoimenpiteestä ja suunnitelmaan perustuva kustannusarvio.
        </p>

        <div style="margin-top: 20px;">
          <div v-if="result">
            <result-page-operation :operation="result.operations[0]" />
          </div>
          <ajax-loader v-else :message="'Ladataan laskennan tulosta...'" />
        </div>

        <br />
        <back-button :to="backUrl" />
      </div>
    </div>
  </layout>
</template>


<script>
  import { mapState } from 'vuex'
  import Layout from './Layout'
  import ResultPageOperation from './ResultPageOperation'

  export default {
    props: {
      initParams: null,
      result: null,
      backUrl: null,
      reportUrl: null
    },

    components: {
      Layout,
      ResultPageOperation
    }
  }
</script>


<style scoped>
  .result-page {
    background-color: white;
    padding-top: 10px;
    padding-bottom: 10px;
  }
</style>



// WEBPACK FOOTER //
// src/components/ResultPage.vue